import { Button, Empty, Flex } from 'antd';
import { SectionTitle } from '../styles';
import { Assistance, CauseContainer } from './styles';
import Icon from '@ant-design/icons';
import { SVGOrder, SVGPhone } from '../../../../images';
import Result from './result';
import { Cause } from '../../../../types';
import PossibleCauseItem from './causeItem';
import { useSelector } from 'react-redux';
import { selectRoutines } from '../../../../slices/templates';

export interface PossibleCause extends Cause {
  ratio: number;
  causeID: string;
  causeName: string;
}

const PossibleCauses = ({
  identified,
  causes,
}: {
  identified?: boolean;
  causes: PossibleCause[];
}) => {
  const routines = useSelector(selectRoutines);
  const routine = routines.find(
    (i) => String(i.linkedCause?.causeID) === String(causes?.[0]?.causeID)
  );

  return (
    <CauseContainer className={identified ? 'identified' : ''}>
      <SectionTitle>
        {identified ? 'Identified Causes' : 'Possible Causes'}
        <span>({causes.length})</span>
      </SectionTitle>
      <Flex flex={1} vertical gap={8} style={{ overflowY: 'auto' }}>
        {causes.length ? (
          causes.map((c, index) =>
            c ? (
              <PossibleCauseItem
                key={c.causeID}
                causes={causes}
                cause={c}
                index={index}
              />
            ) : null
          )
        ) : (
          <Empty description="No possible causes" />
        )}

        {identified && <Result routine={routine} />}
      </Flex>
      <Assistance>
        <p>Need assistance</p>
        <Flex gap={24}>
          <Button ghost type="primary" icon={<Icon component={SVGPhone} />}>
            Call Machine Builder
          </Button>
          <Button ghost type="primary" icon={<Icon component={SVGOrder} />}>
            Create a Ticket
          </Button>
        </Flex>
      </Assistance>
    </CauseContainer>
  );
};

export default PossibleCauses;
